var _defs, _g, _ellipse, _ellipse2, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneric2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "generic2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.24 233.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-9{opacity:0.44;}.cls-2,.cls-9{fill:#95c3fa;}.cls-3{fill:#75b2fc;}.cls-4{fill:#00479b;}.cls-5{fill:#dceeff;}.cls-6{fill:#2e83ea;}.cls-7{fill:#fff;}.cls-8{fill:#fdfeff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 264.34,
    cy: 140.05,
    rx: 19.9,
    ry: 19.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 263.23,
    cy: 141.25,
    rx: 19.9,
    ry: 19.16
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 63.73,
    cy: 58.1,
    rx: 60.34,
    ry: 58.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 60.34,
    cy: 61.73,
    rx: 60.34,
    ry: 58.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2912.14,953.08H2786.79a28.86,28.86,0,0,1-28.86-28.86V811.83A28.87,28.87,0,0,1,2786.79,783h125.35c15.94,0,28.86,18.26,28.86,28.87V924.22A28.86,28.86,0,0,1,2912.14,953.08Z",
    transform: "translate(-2710.75 -750.65)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 41.28,
    y: 38.02,
    width: 183.08,
    height: 170.12,
    rx: 28.86
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 166.99,
    y: 89.96,
    width: 98.73,
    height: 91.74,
    rx: 28.86
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 161.19,
    y: 94.78,
    width: 98.73,
    height: 91.74,
    rx: 20.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 62.63,
    y: 69.76,
    width: 98.56,
    height: 4.38
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 62.63,
    y: 82.9,
    width: 76.08,
    height: 4.38
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 62.63,
    y: 100.42,
    width: 76.08,
    height: 4.38
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 62.63,
    y: 159.53,
    width: 98.56,
    height: 4.38
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.28,
    y: 151.9,
    width: 64.56,
    height: 4.38
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.35,
    y: 164.76,
    width: 64.56,
    height: 4.38
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2971.41,811.86c-6.5-4.36-16.29-6.94-18.83-2.87-2,3.28,1.06,10.12,5.77,14.5,5,4.67,8.87,3.73,16.53,9.55,6.77,5.15,8.45,9.45,10,9.59C2988.24,842.93,2985.87,821.58,2971.41,811.86Z",
    transform: "translate(-2710.75 -750.65)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2922,891.61l-1.73,2a1.3,1.3,0,0,1-1.85.13L2903,880.12a1.34,1.34,0,0,1-.13-1.87l1.74-2a1.3,1.3,0,0,1,1.85-.12l15.45,13.62A1.33,1.33,0,0,1,2922,891.61Z",
    transform: "translate(-2710.75 -750.65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2947.41,862.56h0c.93.93.93,2.44-.47,4.37a.22.22,0,0,1-.07.09L2921,893.09a.72.72,0,0,1-.58.21,4.17,4.17,0,0,1-2.54-1h0a2.42,2.42,0,0,1,0-3.4L2944,862.56A2.37,2.37,0,0,1,2947.41,862.56Z",
    transform: "translate(-2710.75 -750.65)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2751.73,963.28a46.61,46.61,0,0,0,6.37,2.75c2.27.76,3.35.8,5.21,1.36,6,1.82,9.3,2.85,11.26,5.39s1.48,7.54-.92,9.75c-3.52,3.21-10.53.14-14.89-1.77a37.64,37.64,0,0,1-10.53-6.89c-13.84-13.15-21.17-36.08-19.83-36.69S2744.27,959.28,2751.73,963.28Z",
    transform: "translate(-2710.75 -750.65)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric2);
export default __webpack_public_path__ + "static/media/Generic2.d8f12e25529a8ea1a4fed3fdc992b10e.svg";
export { ForwardRef as ReactComponent };